import { Capacitor } from '@capacitor/core';
import { validateToken } from 'common/utils/network/endpoints';
import { baseApi } from 'common/store/baseApi';
import { ValidateTokenRequest, ValidateTokenResponse } from './types';

export const validateTokenApi = baseApi
  .enhanceEndpoints({ addTagTypes: [] })
  .injectEndpoints({
    endpoints: (builder) => ({
      validateToken: builder.mutation<ValidateTokenResponse, ValidateTokenRequest>({
        query: () => ({
          url: validateToken,
          method: 'GET',
          // Only native builds have a share extension; the web client calls
          // validate-token constantly and asking there would just flood
          // personal_access_tokens with scoped tokens nothing ever reads.
          params: Capacitor.isNativePlatform() ? { include_share_token: 1 } : undefined,
        }),
      }),
    }),
  });

export const {
  useValidateTokenMutation,
} = validateTokenApi;
